<h3-feedback-pane
  [dialogTitle]="dialogTitle$ | async"
  (dialogClose)="closeDialog()"
>
  <form class="popover-body" [formGroup]="form" h3ScrollEnabler>
    <mat-form-field>
      <mat-label>Issue type</mat-label>
      <mat-select formControlName="issueType">
        <mat-option
          *ngFor="let type of clientFeedbackTypeLabels"
          [value]="clientFeedbackTypes[type]"
          >{{ type }}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Title</mat-label>
      <input matInput type="text" formControlName="title" />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Description</mat-label>
      <textarea matInput formControlName="description"></textarea>
      <div class="add-screenshot">
        <ng-container *ngIf="selectedIssueId$ | async; else uploadedImage">
          <div class="screenshot-container" h3ScrollEnabler>
            <a
              [href]="screenshot.preSignedUrl"
              target="_blank"
              *ngFor="let screenshot of attachments$ | async"
            >
              <img
                class="screenshot"
                [ngSrc]="screenshot.preSignedUrl"
                width="72"
                height="76"
              />
            </a>
          </div>
        </ng-container>
        <ng-template #uploadedImage>
          <button
            mat-button
            type="button"
            color="primary"
            (click)="fileInput.click()"
          >
            <mat-icon>crop_original</mat-icon>
            UPLOAD IMAGES
          </button>
          <input
            (change)="addScreenshots($event)"
            #fileInput
            type="file"
            accept="image/*"
            multiple
          />
          <div class="screenshot-container" h3ScrollEnabler>
            <img
              class="screenshot"
              [src]="screenshot.url"
              *ngFor="
                let screenshot of form.controls.screenshots.valueChanges | async
              "
            />
          </div>
        </ng-template>
      </div>
    </mat-form-field>
    <h3-autocomplete-chips
      [allowedValues]="clientFeedbackTags$ | async"
      [availableValuesOnly]="false"
      [allowDuplicatedValue]="false"
      [formControl]="form.controls.tags"
      [autoCompleteValueOnEnter]="false"
      label="Tags"
    ></h3-autocomplete-chips>

    <!-- We need to wrap the checkbok in a div because tooltips aren't displayed
       for disabled elements-->
    <div [matTooltip]="disabledParkTaskTooltip">
      <mat-checkbox formControlName="parkTask">Park task</mat-checkbox>
    </div>
    <div class="popover-action">
      <button
        mat-button
        type="button"
        color="primary"
        [disabled]="form.invalid"
        (click)="saveIssue()"
      >
        SAVE
      </button>
    </div>
  </form>
</h3-feedback-pane>
